import { MagnifyingGlass, ArrowCounterClockwise } from "@phosphor-icons/react";
import { STATUSES } from "../../lib/api";

export const OrdersFilters = ({ search, setSearch, status, setStatus, aging, setAging, dateFrom, setDateFrom, dateTo, setDateTo, onReset }) => (
  <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
    <div className="grid grid-cols-2 items-end gap-3 md:flex md:flex-wrap">
      <div className="col-span-2 md:min-w-[220px] md:flex-1">
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Search</label>
        <div className="relative mt-1">
          <MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="orders-search-input" value={search} onChange={(e) => setSearch(e.target.value)}
            placeholder="Customer, location or order #"
            className="w-full rounded-md border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
        </div>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Status</label>
        <select data-testid="orders-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}
          className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none md:w-auto">
          <option value="">All statuses</option>
          {STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Aging</label>
        <select data-testid="orders-aging-filter" value={aging} onChange={(e) => setAging(e.target.value)}
          className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none md:w-auto">
          <option value="">All</option>
          <option value="green">Fresh (&lt;3d)</option>
          <option value="yellow">Nearing (3–7d)</option>
          <option value="red">Overdue (&gt;7d)</option>
        </select>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">From</label>
        <input data-testid="orders-date-from" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)}
          className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none md:w-auto" />
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">To</label>
        <input data-testid="orders-date-to" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)}
          className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none md:w-auto" />
      </div>
      <button data-testid="orders-reset-filters" onClick={onReset}
        className="col-span-2 flex items-center justify-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-600 transition-colors duration-150 hover:bg-slate-100 md:col-span-1">
        <ArrowCounterClockwise size={14} /> Reset
      </button>
    </div>
  </div>
);
